export const userAgentUtils = () => {
  // モバイルアクセスである
  const isMobile: boolean = /iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // タブレットアクセスである
  const isTablet: boolean =
    /iPad|Tablet|PlayBook|Silk/i.test(navigator.userAgent) || (/macintosh/i.test(navigator.userAgent) && document.ontouchstart !== undefined);

  // PCアクセスである
  const isPc: boolean = !(isMobile || isTablet);

  return { isMobile, isTablet, isPc };
};
